import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, Table, TableBody, TableHeader, TableItem, TableRow} from 'spectacle';
import {format} from 'date-fns';
import {Slide} from '../components/slide';
import {Month} from '../support/import_csv';
import {formatEuro} from '../../support/format_money';
import {toQuarters} from '../support/quarters';
import {Footnote} from '../components/footnote';
import {ResultPercentage} from '../components/result_percentage';
import {toYears} from '../support/years';

interface OwnProps {
    referenceDate: Date;
    months: Month[];
}

export const QuarterResultComparison: FunctionComponent<OwnProps> = ({months, referenceDate}) => {
    const quarters = toQuarters(months, referenceDate);
    const years = toYears(months, referenceDate);
    return (
        <Slide>
            <Heading size={1} textAlign="left" textColor="secondary">
                Quarterly result
            </Heading>
            <Heading size={3} textAlign="left" textColor="tertiary">
                {format(referenceDate, 'yyyy')}
            </Heading>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableItem />
                        {quarters[0].history.map((item) => {
                            return <TableItem>{item.date.getFullYear()}</TableItem>;
                        })}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {quarters.map((quarter) => {
                        return (
                            <TableRow key={String(quarter)}>
                                <TableItem key="q">Q{quarter.quarter + 1}</TableItem>
                                {quarter.history.map((item, i) => {
                                    if (item.months.length === 0) {
                                        return <TableItem key={item.date.getTime()} />;
                                    }
                                    return (
                                        <TableItem
                                            key={item.date.getTime()}
                                            textColor={
                                                referenceDate.getFullYear() !== item.date.getFullYear() ||
                                                item.months.length !== 3
                                                    ? 'tertiary'
                                                    : ''
                                            }>
                                            <span style={{marginRight: 20}}>{formatEuro(item.result)}</span>
                                            <ResultPercentage factor={item.result / item.revenue} />
                                        </TableItem>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                    <TableRow>
                        <TableItem />
                        {years.map((year) => {
                            return (
                                <TableItem
                                    textColor={referenceDate.getFullYear() !== year.year ? 'tertiary' : ''}
                                    style={{borderTop: '1px solid black'}}>
                                    <span style={{marginRight: 20}}>{formatEuro(year.result)}</span>
                                    <ResultPercentage factor={year.result / year.revenue} />
                                </TableItem>
                            );
                        })}
                    </TableRow>
                </TableBody>
            </Table>
            <Footnote>*Percentage represents profit margin</Footnote>
        </Slide>
    );
};
